import { render, staticRenderFns } from "./AsianaMileage.vue?vue&type=template&id=5b3501e2"
import script from "./AsianaMileage.vue?vue&type=script&lang=js"
export * from "./AsianaMileage.vue?vue&type=script&lang=js"
import style0 from "./AsianaMileage.vue?vue&type=style&index=0&id=5b3501e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports